module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/church-organization-application.json
// module id = 710
// module chunks = 86777579858086